export default "__VITE_ASSET__DQOQvwsy__"